import { Box, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type Props = {
  numberOfExpiredParticipants: number | null | undefined
  totalParticipants: number
}

export const Participants = ({ numberOfExpiredParticipants, totalParticipants }: Props) => {
  const [hover, setHover] = useToggle()
  const showAlert = numberOfExpiredParticipants && numberOfExpiredParticipants > 0
  return (
    <Box flexDirection="row" gap="s8">
      <Text.Normal>{totalParticipants}</Text.Normal>
      {showAlert ? (
        <Tooltip.Alt
          attachment="bottom left"
          open={hover}
          label={i18n.tp('trainings.trainings_table.expired_participants', {
            count: numberOfExpiredParticipants,
          })}
          toggle={setHover}
        >
          <Tag type="tangerine" iconColor="tangerine1000" leftItem="icon" icon="alert-circle">
            {numberOfExpiredParticipants}
          </Tag>
        </Tooltip.Alt>
      ) : (
        ''
      )}
    </Box>
  )
}
